var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{staticClass:"c-input-text",class:{
      'c-input-text--error': _vm.error,
      'c-input-text--has_icon': _vm.hasIcon,
      'c-input-text--has_suffix': _vm.hasSuffix
    },attrs:{"type":_vm.type,"id":_vm.id,"name":_vm.name,"min":_vm.min,"disabled":_vm.disabled,"error":_vm.error,"placeholder":_vm.placeholder,"maxlength":_vm.maxlenght},domProps:{"value":_vm.value},on:{"input":_vm.updateValue,"focus":_vm.focus,"blur":_vm.blur}}),(_vm.$slots.lastLabel)?_c('span',[_vm._t("lastLabel")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }